<template>
    <zen-one
        :showuserinfo="false"
        :crumbs="crumbs"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
    >
        <z-page title="Kaunter : Tutup Sementara ">
            <div class="message-box">
                <w-transition-fade>
                    <w-alert
                        class="my0 text-light"
                        v-if="form.submitted"
                        success
                        no-border
                    >
                        The form is valid, ready to send it!
                    </w-alert>

                    <w-alert
                        class="my0 text-light"
                        v-else-if="form.valid === false"
                        error
                        no-border
                    >
                        Terdapat {{ form.errorsCount }} ralat di dalam borang
                        ini.
                    </w-alert>
                </w-transition-fade>
            </div>

            <w-form
                class=""
                v-model="form.valid"
                v-model:errors-count="form.errorsCount"
                @validate="onValidate"
                @success="onSuccess"
            >
                <w-flex justify-center align-center class="mt5">
                    <div class="w-card__content content-hardcode">
                        <table class="table-dashboard" width="100%">
                            <thead>
                                <tr>
                                    <td>Tarikh</td>
                                    <td>Kaunter</td>
                                    <td>Tunai (RM)</td>
                                    <td>Cek (RM)</td>
                                    <td>Wang Pos (RM)</td>
                                    <td>Bank Deraf (RM)</td>
                                    <td>Kiraman Wang (RM)</td>
                                    <td>Kad Kredit (RM)</td>
                                    <td>Kad Debit (RM)</td>
                                    <td>EFT (RM)</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {{ currentDate() }}
                                    </td>
                                    <td>
                                        <template v-if="form.kaunter">{{
                                            form.kaunter.kod
                                        }}</template>
                                    </td>
                                    <td>
                                        {{ $zutil.currency(form.tunai) }}
                                    </td>
                                    <td>
                                        {{ $zutil.currency(form.cek) }}
                                    </td>
                                    <td>
                                        {{ $zutil.currency(form.wangpos) }}
                                    </td>
                                    <td>
                                        {{ $zutil.currency(form.bankderaf) }}
                                    </td>
                                    <td>
                                        {{ $zutil.currency(form.kirimanwang) }}
                                    </td>
                                    <td>
                                        {{ $zutil.currency(form.kadkredit) }}
                                    </td>
                                    <td>
                                        {{ $zutil.currency(form.kaddebit) }}
                                    </td>
                                    <td>
                                        {{ $zutil.currency(form.eft) }}
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="1">Jumlah</td>
                                    <td align="left">
                                        <b>
                                            {{
                                                $zutil.currency(
                                                    form.eft +
                                                        form.kaddebit +
                                                        form.kadkredit +
                                                        form.kirimanwang +
                                                        form.bankderaf +
                                                        form.wangpos +
                                                        form.cek +
                                                        form.tunai
                                                )
                                            }}</b
                                        >
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </w-flex>

                <w-flex justify-center align-cente class="mt2">
                    <div class="xs12">
                        <w-textarea
                            no-autogrow
                            rows="8"
                            placeholder="Sila Masukkan Catatan Disini"
                            v-model="form.catatan"
                        >
                            Catatan
                        </w-textarea>
                    </div>
                </w-flex>

                <w-flex class="mt4" wrap align-center justify-end>
                    <div class="spacer" />
                    <template v-if="$zutil.can('Kaunter Tutup Sementara')">
                        <w-button
                            class="my1"
                            type="submit"
                            :disabled="form.valid === false"
                            :loading="form.submitted && !form.sent"
                        >
                            <w-icon dark tile>fal fa-save</w-icon>
                        </w-button>
                    </template>

                    <template v-if="form.ind_buka == 0">
                        <!-- <template v-if="form.user_id == $page.props.auth.user.id"> -->
                        <w-button class="ml1" @click="send(3, form)">
                            Tutup
                        </w-button>
                        <!-- </template> -->
                    </template>
                </w-flex>
            </w-form>
        </z-page>
    </zen-one>
</template>

<script>
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        Vue3ChartJs,
    },
    props: {
        id: [Array, Object, String],
    },
    setup() {
        const doughnutChart = {
            id: "doughnut",
            type: "doughnut",
            data: {
                labels: ["VueJs", "EmberJs", "ReactJs", "AngularJs"],
                datasets: [
                    {
                        backgroundColor: [
                            "#37479e",
                            "#2f3d88",
                            "#273371",
                            "#1f285a",
                        ],
                        data: [40, 20, 80, 10],
                    },
                ],
            },
            options: { plugins: { legend: { display: false } } },
        };

        const beforeRenderLogic = (event) => {
            //...
            //if(a === b) {
            //  event.preventDefault()
            //}
        };

        return {
            doughnutChart,
            beforeRenderLogic,
        };
    },
    data() {
        return {
            resourceurl: this.service_kutipan + "kaunter/summary",
            dialog: {
                show: false,
                show2: false,
                fullscreen: false,
                persistent: false,
                persistentNoAnimation: false,
                width: 500,
            },
            form: {
                valid: null,
                submitted: false,
                sent: false,
                errorsCount: 0,
            },
            validators: {
                required: (value) => !!value || "This field is required",
                consent: (value) => !!value || "You must agree",
            },
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan" },
                { label: "Kaunter", route: "/kaunter" },
                { label: "Tutup Sementara", route: "/Kaunter/sementara" },
            ],
            showCard: false,
        };
    },
    methods: {
        onSuccess() {
            setTimeout(() => (this.form.sent = true), 2000);
            this.$inertia.visit(window.route("kutipan.kaunter.sementara"));
        },
        onValidate() {
            this.form.sent = false;
            this.form.submitted = this.form.errorsCount === 0;
        },

        currentDate() {
            const current = new Date();
            const date = `${current.getDate()}/${
                current.getMonth() + 1
            }/${current.getFullYear()}`;
            return date;
        },

        send(status, form) {
            this.form.lkp_kaunter_status_id = status;
            this.form.id = form.kaunter_id;
            this.form.profil_id = 0;
            this.$zcomm
                .update(
                    this.service_kutipan + "kaunter" + "/" + this.form.id,
                    this.form.id,
                    this.form
                )
                .then((res) => {
                    this.$zutil.notify("Kaunter Berjaya Ditutup Sementara");
                    this.$inertia.visit(this.$route("kutipan.kaunter.buka"));
                })
                .catch((err) => {})
                .finally(() => {});
        },
    },
};
</script>

<style></style>
